import { PcbCol } from '@/types/entities';

export const PcbColNames = {
  [PcbCol.standart]: 'Стандарт',
  [PcbCol.proto]: 'Топ (прототипы)',
  [PcbCol.express]: 'Срочное производство',
};
